document.addEventListener('DOMContentLoaded', () => {
  fixedElementsHeight()
  $(window).on('resize:width', fixedElementsHeight)
  $(window).on('load', fixedElementsHeight)
})

export function fixedElementsHeight() {
  let fixedHeight = 0
  fixedHeight += $('.header-container').height() || 0
  fixedHeight += $('.section-nav').height()      || 0

  document.documentElement.style.setProperty('--fixed-elements-height', fixedHeight + 'px')
}
